import React from 'react'

import Text from '@components/kit/text'
import { Row } from '@components/kit/grid'

import {
  ColumnWrapper,
  HorizontalRule,
  LabelText,
  RowWrapper,
  ValueText
} from '@components/table'
import { GLP1Onboarding } from '@store/HealthTracking/types'

interface GLP1MedsProps {
  onboarding: GLP1Onboarding | null
}

function GLP1Meds({ onboarding }: GLP1MedsProps) {
  return (
    <>
      <RowWrapper>
        <LabelText font='display.14.bold'>Medications</LabelText>
      </RowWrapper>

      {onboarding ? (
        <Row width='100%'>
          <ColumnWrapper width='50%'>
            <LabelText>Medication Name</LabelText>
            <ValueText>{onboarding.glp1_medication_name || '-'}</ValueText>
          </ColumnWrapper>
          <ColumnWrapper width='50%'>
            <LabelText>Dosage</LabelText>
            <ValueText>{onboarding.dosage || '-'}</ValueText>
          </ColumnWrapper>
        </Row>
      ) : (
        <RowWrapper>
          <Text font='display.14.bold' textColor='newMutedPurple'>
            No medication information available.
          </Text>
        </RowWrapper>
      )}

      <HorizontalRule />
    </>
  )
}

export default GLP1Meds
